export const costs = [
  'You build every genetics lesson from scratch, hunting for DNA diagrams and Punnett squares scattered across the internet',
  'Students mix up genes, alleles and chromosomes and get lost between DNA, RNA and proteins',
  "You don't have clear visuals, worked examples and activities ready to use in class",
  'You lack the time to plan a complete, coherent genetics unit — from DNA to CRISPR and evolution',
];
